<template>
  <div
    v-if="!isEmpty(value)"
    class="flex h-[26px] w-auto grow-0 justify-center rounded-full border border-gray-200 px-2-5 py-2 text-center text-xxs font-bold whitespace-nowrap uppercase"
    :style="background"
  >
    <div class="flex place-self-center overflow-hidden" :style="{ color }">
      {{ value }}
    </div>
  </div>
  <div v-else>-</div>
</template>
<script
  setup
  lang="ts"
  generic="
    TWorkflowStatusable extends {
      workflow_status: WorkflowSnapshotStatus;
    }
  "
>
import { computed } from "vue";

import isEmpty from "lodash/isEmpty";

import { DEFAULT_WORKFLOW_STATUS_COLOR } from "@/helpers/constants";
import { hexToRgb } from "@/helpers/formatting";

import type { WorkflowSnapshotStatus } from "@/models/applications";

const props = defineProps<{
  value: string;
  model: TWorkflowStatusable;
}>();

const color = computed(() => {
  const statusColor = String(
    props.model.workflow_status?.color
  ).toLocaleLowerCase();

  return hexToRgb(statusColor) ? statusColor : DEFAULT_WORKFLOW_STATUS_COLOR;
});

const background = computed(() => {
  return {
    backgroundColor: color.value + "10",
    borderStyle: "none",
  };
});
</script>
